import React, { useEffect, useState } from "react"
import { Form, Modal, Select } from "antd"
import { useDebounce } from "use-debounce"
import CustomSelect from "../../../components/CustomSelect"
import CustomButton from "../../../components/CustomButton"
import CustomInput from "../../../components/CustomInput"
import Notifications from "../../../helpers/Notifications"
import api from "./api"
import { useTranslation } from "react-i18next"
import apiMeasurementUnit from "../ReMeasurementUnit/store/api.js"
import {setFormErrors} from "../../../helpers/formErrors";
const { Option } = Select

const ReMechanismChangeForm = (props) => {
	const [loading, setLoading] = useState(false)
	const [measurements, setMeasurementUnits] = useState([])
	const [searchMeasurementUnit, setSearchMeasurementUnit] = useState('')
	const [measurement] = useDebounce(searchMeasurementUnit, 500)
	const { visible, setVisible, setRecord, record, changed } = props
	const {t} = useTranslation(['common', 'valid', 'action'])
	const [form] = Form.useForm()

	const create = params => {
		action(api.create, params, changed, t('action:created'))
	}
	const update = params => {
		action(api.update, params, changed, t('action:updated'))
	}

	const action = (func, params, sucFunction, sucParams) => {
		setLoading(true)
		func(params)
			.then(res => sucFunction(res, sucParams))
			.catch(err => {
				setFormErrors(err, form)
			})
			.finally(() => setLoading(false))
	}

	useEffect(() => {
		form.resetFields()
		if (record) {
			if (record.reMeasurementUnit.id != null && !measurements.find(m => m.id === record.reMeasurementUnit.id)){
				setMeasurementUnits([...measurements, record.reMeasurementUnit])
			}
			form.setFieldsValue({
				code              : record.code,
				name              : record.name,
			    codeKKM           : record.codeKKM, 
                reMeasurementUnit : record.reMeasurementUnit?.id
			})
		}
	}, [record])

	useEffect(() => {
		const values = {name: measurement?.trim()}
		const sucFunction = res => setMeasurementUnits(res)
		action(apiMeasurementUnit.getList, values, sucFunction, null)
	}, [measurement])

	function handleCancel(){
		form.resetFields()
		setRecord(null)
		setVisible(false)
	}

	const save = () => {
		form.validateFields().then(values => {
			const updateValues = {
				id         : record?.id,
				code       : values.code,
                codeKKM    : values.codeKKM,
				name       : values.name.trim(),
                ReMeasurementUnitId : values.reMeasurementUnit,
				isDeleted  : record?.isDeleted
			}
			const previousValues = {
				id                  : record?.id,
				code                : record?.code,
                codeKKM             : record?.codeKKM,
				name                : record?.name,
				ReMeasurementUnitId : record?.reMeasurementUnit.id,
				isDeleted           : record?.isDeleted
			}
			if (JSON.stringify(updateValues) === JSON.stringify(previousValues))
				Notifications.errorNotice(t('valid:sameData'), null, 20)
			else
				record ? update(updateValues) : create(updateValues)
		})
	}

	return (
		<Modal
			destroyOnHidden
			footer={[
				<CustomButton
					key="save"
					loading={loading}
					type="green"
					onClick={save}
				>
					{t('action:save')}
				</CustomButton>
			]}
			title={record ? t('action:editRecord') : t('action:addRecord')}
			open={visible}
			width={900}
			onCancel={handleCancel}
		>
			<Form
				form={form}
				labelAlign="left"
				labelCol={{span: 6}}
				name="nsi-form"
				wrapperCol={{span: 17, offset: 1}}
			>
				<Form.Item
					label={t('common:code')}
					name="code"
					rules={[
						{
							required   : true,
							whitespace : true,
							message    : t('valid:codeFilledBad'),
							pattern    : /^[1-9]\d{0,6}$/
						}
					]}
				>
					<CustomInput
					    disabled = {record}
						placeholder={`${t('action:enter')} ${t('common:code').toLowerCase()}`}
					/>
                    
				</Form.Item>
                <Form.Item
					label={t('common:codeKKM')}
					name="codeKKM"
					rules={[
						{
							required   : true,
							whitespace : true,
							message    : t('valid:codeFilledBad'),
							pattern    : /^[1-9]\d{0,6}$/
						}
					]}
				>
					<CustomInput
					   	placeholder={`${t('action:enter')} ${t('common:codeKKM').toLowerCase()}`}
					/>
                    </Form.Item>
			
				<Form.Item
					label={t('common:title')}
					name="name"
					rules={[
						{
							required   : true,
							whitespace : true,
							min        : 3,
							max        : 200
						}
					]}
				>
					<CustomInput
						maxLength={ 250 }
						placeholder={`${t('action:enter')} ${t('common:title').toLowerCase()}`}
					/>
				</Form.Item>
				<Form.Item
					label={t('common:measurement')}
					name="reMeasurementUnit"
					rules={ [{ required: true }] }
				>
					<CustomSelect
						allowClear
						showSearch
						filterOption={false}
						notFoundContent={null}
						placeholder={`${t('action:choose')} ${t('common:measurement').toLowerCase()}`}
						onSearch={(e) => setSearchMeasurementUnit(e)}
					>
						{ measurements?.map(item => {
							return (
								<Option
									key={item.id}
									value={item.id}
								>
									{item.name}
								</Option>)
						}) }
					</CustomSelect>
				</Form.Item>
			</Form>
		</Modal>
	)
}
export default ReMechanismChangeForm